import classNames from 'classnames'
import React from 'react'

import Icon, {Icons} from '../icons/Icon'

export type PillTypes =
  | 'navy'
  | 'alert'
  | 'warning'
  | 'green'
  | 'primary'
  | 'purple'
  | 'neutral'
  | 'neutral-light'
  | 'transparent';

export type PillSizes = 'sm' | 'md' | 'lg'
export type TextTransform = 'normal-case' | 'uppercase' | 'lowercase' | 'capitalize-all' | 'capitalize-first'

export interface PillProps {
  type: PillTypes;
  size?: PillSizes;
  icon?: Icons;
  text: string;
  textTransform?: TextTransform;
}

const Pill = ({type, size = 'md', icon, text, textTransform = 'normal-case'}: PillProps) => {
  const pillClassnames = classNames('w-fit flex items-center font-semibold font-titillium rounded',
    {
      'bg-kwota-navy-100 text-kwota-navy-300': type === 'navy',
      'bg-kwota-alert-100 text-kwota-alert-400': type === 'alert',
      'bg-kwota-warning-100 text-kwota-warning-400': type === 'warning',
      'bg-kwota-green-100 text-kwota-green-400': type === 'green',
      'bg-kwota-primary-100 text-kwota-primary-600': type === 'primary',
      'bg-kwota-purple-100 text-kwota-purple-400': type === 'purple',
      'bg-kwota-neutral-300 text-kwota-neutral-800': type === 'neutral',
      'bg-kwota-neutral-300 text-kwota-neutral-500': type === 'neutral-light',
      'text-black': type === 'transparent',

      'text-lg py-1.5 px-3': size === 'lg',
      'text-base py-1 px-2': size === 'md',
      'text-sm py-0.5 px-1.5': size === 'sm'
    }
  )

  const textClasses = classNames(textTransform, {
    'first-letter:capitalize': textTransform === 'capitalize-first',
    'capitalize': textTransform === 'capitalize-all'
  })

  const iconClassnames = classNames({
    'fill-kwota-navy-300': type === 'navy',
    'fill-kwota-alert-400': type === 'alert',
    'fill-kwota-warning-400': type === 'warning',
    'fill-kwota-green-400': type === 'green',
    'fill-kwota-primary-600': type === 'primary',
    'fill-kwota-purple-400': type === 'purple',
    'fill-kwota-neutral-800': type === 'neutral',
    'fill-kwota-neutral-500': type === 'neutral-light',
    'fill-black': icon && type === 'transparent',

    'mr-2.5': size === 'lg',
    'mr-[7.67px]': size === 'md',
    'mr-[5.33px]': size === 'sm'
  })

  return (
    <div className={`${pillClassnames}`}>
      {icon && <Icon icon={icon} size={size === 'lg' ? 'md' : 'sm' } className={`${iconClassnames} cursor-auto mr-2.5`} />}
      <span className={textClasses}>
        {text}
      </span>
    </div>
  )
}

export default Pill
